import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getAllEmployeebyPagination, syncAllEmployeebyPagination, getAllEmployeebyPaginationInactive } from "../../../actions/employeeAction";
import Rendertable from "./Rendertable";
import { getAllLocation } from "../../../actions/warehouseAction";
import { getAllUserRole } from "../../../actions/userRoleAction";
import { Tabs, Button } from "antd";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";

const EmployeeList = ({
  getAllEmployeebyPagination,
  getAllEmployeebyPaginationInactive,
  employeeList,
  getAllLocation,
  reload,
  setReload,
  setData,
  loading,
  setloading,
  location,
  Designation,
  Department,
  Keyword,
  isWorker, 
  flag,
  data,
  pageno,
  page_size,
}) => {
  const [activeEmployee, setActiveEmployee] = useState([]);
  const [inactiveEmployee, setInactiveEmployee] = useState([]);
  const [loadingActive, setLoadingActive] = useState(true);
  const [loadingInactive, setLoadingInactive] = useState(true);
  const [activatekey, setActivatekey] = useState(1);

  useEffect(() => {
    setLoadingActive(true);
    setLoadingInactive(true);
    if (activatekey == 1) {
      getAllEmployeebyPagination(location.current, Designation.current, Department.current, Keyword.current, isWorker.current, pageno.current, page_size.current)
        .then((e) => {
          setActiveEmployee(e);
          setLoadingActive(false);
        });
    } else {
      getAllEmployeebyPaginationInactive(location.current, Designation.current, Department.current, Keyword.current, isWorker.current, pageno.current, page_size.current)
        .then((res) => {
          setInactiveEmployee(res);
          setLoadingInactive(false);
        });
    }
  }, [reload]);

  const onChange = (key) => {
    console.log(key);
    setActivatekey(key)
    pageno.current = 1;
    setReload(!reload)
  };

  const exportToExcel = (employeeType) => {
    const employeeData = employeeType === 'active' ? activeEmployee : inactiveEmployee;
    
    if (!employeeData || !employeeData.results || employeeData.results.length === 0) {
      return;
    }

  const dataToExport = employeeData.results.map(employee => {
    const hiredDate = employee.joining_date 
      ? new Date(employee.joining_date).toISOString().split('T')[0] 
      : '';
    
    return {
      PIN: employee.employee_pin,
      Name: employee.name,
      Department: employee.employeeDepartment,
      Designation: employee.user_roleName,
      HiredDate: hiredDate,
    };
  });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    
    const sheetName = employeeType === 'active' ? "Active Employees" : "Resigned Employees";
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  
    const fileName = employeeType === 'active' ? "Active_Employees.xlsx" : "Resigned_Employees.xlsx";
    XLSX.writeFile(wb, fileName);
  };

  const hasActiveEmployees = activeEmployee && activeEmployee.results && activeEmployee.results.length > 0;
  const hasResignedEmployees = inactiveEmployee && inactiveEmployee.results && inactiveEmployee.results.length > 0;

  return (
    <>
      <Tabs defaultActiveKey="1" style={{ width: "100%" }} onChange={onChange}>
        <Tabs.TabPane 
          tab={
            <span>
              Active Employees
              {hasActiveEmployees && (
                <Button 
                  type="link" 
                  icon={<DownloadOutlined />} 
                  onClick={() => exportToExcel('active')}
                  style={{ marginLeft: 10 }}
                >
                  Export
                </Button>
              )}
            </span>
          } 
          key="1"
        >
          <Rendertable
            loading={loadingActive}
            List={activeEmployee}
            reload={reload}
            setReload={setReload}
            pageno={pageno}
            page_size={page_size}
            flag={flag}
          />
        </Tabs.TabPane>
        <Tabs.TabPane 
          tab={
            <span>
              Resigned Employees
              {hasResignedEmployees && (
                <Button 
                  type="link" 
                  icon={<DownloadOutlined />} 
                  onClick={() => exportToExcel('inactive')}
                  style={{ marginLeft: 10 }}
                >
                  Export
                </Button>
              )}
            </span>
          } 
          key="2"
        >
          <Rendertable
            loading={loadingInactive}
            List={inactiveEmployee}
            reload={reload}
            setReload={setReload}
            pageno={pageno}
            page_size={page_size}
            flag={flag}
          />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    employeeList: state.employee.employeelistByBranchShift,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeebyPagination,
  getAllEmployeebyPaginationInactive,
  getAllLocation,
  getAllUserRole,
})(EmployeeList);